import { Component, Input, OnInit } from '@angular/core';

/**
 * A reusable component for displaying hint lists with title and bullet points.
 *
 * IMPORTANT: This component is designed to be used inside Angular Material's mat-hint directive.
 * The mat-hint must be a direct child of mat-form-field for proper Material Design integration.
 *
 * Usage:
 * <mat-form-field>
 *   ...
 *   <mat-hint>
 *     <ridango-ui-mat-list-hint titleTerm="TITLE_KEY" listTerm="LIST_KEY"></ridango-ui-mat-list-hint>
 *   </mat-hint>
 *   ...
 * </mat-form-field>
 */

@Component({
    selector: 'ridango-ui-mat-list-hint',
    templateUrl: './mat-list-hint.component.html'
})
export class MatListHintComponent implements OnInit {
    @Input() titleTerm!: string;
    @Input() listTerm!: string;

    ngOnInit(): void {
        if (!this.titleTerm || !this.listTerm) {
            throw new Error('Both titleTerm or listTerm must be provided for StaticListHintComponent');
        }
    }

    stripHtml(html: string): string {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent?.trim() ?? '';
    }
}
